import { Model } from 'pinia-orm';
import { Attr, BelongsTo, MorphMany, Num, Str } from 'pinia-orm/dist/decorators';
import Claim from './Claim';
import Comment from './Comment';
import VariationOrder from './VariationOrder';
/* --- user header --- */
/* --- end user header --- */

export default class VariationOrderCost extends Model {
  static entity = 'App\\Models\\VariationOrderCost';
  // fields
  @Num(0)
  declare id: number;
  @Num(0)
  declare claim_id: number;
  @Num(0)
  declare variation_order_id: number;
  @Num(undefined)
  declare current_claim: number | undefined;
  @Num(undefined)
  declare current_certified: number | undefined;
  @Str('')
  declare created_at: string | undefined;
  @Str('')
  declare updated_at: string | undefined;
  // relations
  @BelongsTo(() => VariationOrder, 'variation_order_id', 'id')
  declare variation_order: VariationOrder;
  @BelongsTo(() => Claim, 'claim_id', 'id')
  declare claim: Claim;
  @MorphMany(() => Comment, 'commentable_id', 'commentable_type', 'id')
  declare comments: Comment[];
  /* --- user code --- */

  @Attr(undefined)
  declare $summaryClaim: number | undefined;
  @Attr(undefined)
  declare $summaryCertified: number | undefined;
  @Attr(undefined)
  declare $head_contract_variation_order_id: Id | undefined;
  /* --- end user code --- */
}
